import { render, staticRenderFns } from "./Finished.vue?vue&type=template&id=97dbe0fe&scoped=true"
import script from "./Finished.vue?vue&type=script&lang=js"
export * from "./Finished.vue?vue&type=script&lang=js"
import style0 from "./Finished.vue?vue&type=style&index=0&id=97dbe0fe&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97dbe0fe",
  null
  
)

export default component.exports